




import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import patientsModel from "../models/user.model";

@Component({
  components: { EntityCrud },
})
export default class Patients extends Vue {
  model: any = patientsModel;

  title = "Pacientes";
  tableColumns = ["email", "name"];
  filter = { role: "PATIENT" };

  //formColumns = ["email", "name", "password", "cpf", "birthDate", "gender", "phoneNumber"];
  formColumns = ["email", "name", "password", "company", "birthDate", "gender", "phoneNumber", "register", "userType"];
  defaultEntity = { role: "PATIENT" };
}
